import RawDataExportModel from '../../models/DataDelivery/RawDataExportModel';
import BaseStore from '../BaseStore';

class RawDataDeliveryStore extends BaseStore {

  constructor(transportLayer) {
    super(RawDataExportModel, transportLayer);
  }
}

export default RawDataDeliveryStore;



// WEBPACK FOOTER //
// ./src/stores/DataDelivery/RawDataExportStore.js